<script>
	import UIButton from "./UIButton.svelte";
	import UIIcon from "./UIIcon.svelte";
	import router from "../stores/router";
	import base from "../stores/base";
	import view from "../stores/view";
	import preload from "../utils/preload";
	import { onDestroy } from "svelte";
	import { fly } from "svelte/transition";

	export let items = [];

	const interval = 5000;
	let index = 0;
	let direction = 0;
	let timerId = 0;
	let duration = 0;
	$: {
		preload(items.map((item) => item.image).filter((i) => !!i));
	}

	onDestroy(() => {
		clearTimeout(timerId);
	});
	function start() {
		if (timerId) {
			clearTimeout(timerId);
		}
		timerId = setTimeout(function () {
			update(1);
		}, interval);
	}
	async function update(diff) {
		direction = diff;
		duration = 800;
		index += diff;
		if (index < 0) {
			index = items.length - 1;
		} else if (index >= items.length) {
			index = 0;
		}
		start();
		setTimeout(() => {
			duration = 0;
		}, 0);
	}
	start();
</script>

<section class="UISlider">
	<div class="UISlider-view">
		<button class="UISlider-view-btn _left" on:click={() => update(-1)}
			><UIIcon type="left" size={$view.mode === "pc" ? 36 : 28} /></button
		>
		<button class="UISlider-view-btn _right" on:click={() => update(1)}
			><UIIcon
				type="right"
				size={$view.mode === "pc" ? 36 : 28}
			/></button
		>
		{#key index}
			<div
				in:fly={{ x: $view.width * 0.05 * direction, duration }}
				out:fly={{ x: -$view.width * 0.05 * direction, duration }}
				class="UISlider-view-image"
				style="background-image:url({($view.mode === 'sp' &&
					items[index].imageSp) ||
					items[index].image})"
				on:click={() => router.push(items[index].url)}
			/>
		{/key}
	</div>
	<div class="UISlider-info">
		<div class="UISlider-info-box">
			<div class="UISlider-info-message">{@html items[index].title}</div>
			<div class="UISlider-info-btn">
				{#if items[index].url}
					<UIButton
						icon="right"
						on:click={() => router.push(items[index].url)}
						>{{ ja: "詳しくはこちら", en: "Details" }[
							$base.lang
						]}</UIButton
					>
				{/if}
			</div>
		</div>
	</div>
</section>

<style global>
	.UISlider-view {
		position: relative;
		height: 500px;
		overflow: hidden;
	}
	.UISlider-view-image {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #eee;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		transform: scale(1.05);
	}
	:global(.pc) .UISlider-view-image {
		background-size: contain;
	}

	:global(.pc) .UISlider-view-image {
		transform: scale(1.1);
	}
	.UISlider-info {
		background: #61788c;
		height: auto;
		padding: 1em;
	}
	:global(.pc) .UISlider-info {
		height: 100px;
		padding: 0 1em;
	}
	.UISlider-info-box {
		align-items: center;
		justify-content: space-between;
		display: flex;
		margin: 0 auto;
		max-width: 1140px;
		height: 100%;
		flex-direction: column;
	}
	:global(.pc) .UISlider-info-box {
		flex-direction: row;
	}

	.UISlider-info-message {
		color: #fff;
		font-size: 1.6em;
		font-weight: bold;
		letter-spacing: 0.06em;
		line-height: 1.25;
		padding-bottom: 1em;
		text-align: center;
	}
	:global(.pc) .UISlider-info-message {
		padding-bottom: 0;
		font-size: 2em;
		text-align: left;
	}
	.UISlider-info-btn {
		color: #fff;
	}

	.UISlider-view-btn {
		border: 2px solid #fff;
		box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
		appearance: none;
		background: none;
		border-radius: 50%;
		text-align: center;
		width: 40px;
		height: 40px;
		cursor: pointer;
		position: absolute;
		padding: 0;
		z-index: 4;
		top: 220px;
	}
	:global(.pc) .UISlider-view-btn {
		width: 66px;
		height: 66px;
	}

	.UISlider-view-btn._left {
		left: 1.5em;
	}
	.UISlider-view-btn._right {
		right: 1.5em;
	}

	.UISlider-view-btn svg {
		stroke: #fff !important;
		vertical-align: middle;
		stroke-width: 1.5px !important;
		filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
	}
</style>
